import React from "react";
import "../Footer/footer.css";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer>
    <div className="footer">
      <div className="logos">
        <img src="../logo-unr.png" alt="Logo UNR" />
        <img src="../fcpolit.png" alt="Logo Facultad de Ciencia Política" />
      </div>
    </div>
    <div className="copy">
      <span>
        &copy; {new Date().getFullYear()} - Universidad Nacional de Rosario -
        Facultad de Ciencia Política y Relaciones Internacionales | Desarrollado con ♥ por <Link to="https://libraweb.com.ar" target="_blank">Libra</Link>
      </span>
    </div>
  </footer>
);

export default Footer;
